import React, { useState, useEffect } from 'react';

/**
 * Splash screen — displays the LifeFinder logo for 3 seconds on application startup.
 * Auto-hides after the timeout. Renders as a full-screen white overlay.
 */
export const Splash: React.FC = () => {
  const [show, setShow] = useState<boolean>(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, bottom: 0, right: 0, background: 'white' }}>
      <div style={{ position: 'fixed', top: '40vmin', left: 0, right: 0, textAlign: 'center' }}>
        <img src="LifeFinder_logo_RGB.png" alt="LifeFinder Logo" style={{ width: '50vmin' }} />
      </div>
    </div>
  );
};
